export default "__VITE_ASSET__9576d412__"